import { useState } from 'react';
import { EstimationInput, EstimationPresets, EstimationSubmit } from '../App';
import { EmissionCalculationInTonnes } from '../configs/industryCalculationTemplate';
import { EstimationForm } from './EstimationForm';
import { EstimationResult } from './EstimationResult';

type Props = {
  onSubmitEstimate: (props: EstimationSubmit) => void;
  onReset: () => void;
  estimationPresets: EstimationPresets;
  calculateEmissionsHref: string;
  countryCode: string;
};

export const EstimationTool = ({
  onSubmitEstimate,
  estimationPresets,
  onReset,
  calculateEmissionsHref,
  countryCode
}: Props): JSX.Element => {
  const [
    estimationInputValues,
    setEstimationInputValues,
  ] = useState<EstimationInput | null>(null);

  const onOffsetClick = (emissionTonnes: EmissionCalculationInTonnes) => {
    if (estimationInputValues)
      onSubmitEstimate({
        emissionInTonnes: emissionTonnes,
        input: estimationInputValues,
      });
  };

  const onFormSubmit = (inputValues: EstimationInput) => {
    setEstimationInputValues(inputValues);
  };
  const resetEstimation = () => {
    setEstimationInputValues(null);
  };
  return (
    <>
      {estimationInputValues ? (
        <EstimationResult
          estimationInputValues={estimationInputValues}
          estimationPresets={estimationPresets}
          onNext={onOffsetClick}
          onReset={resetEstimation}
          calculateEmissionsHref={calculateEmissionsHref}
        />
      ) : (
        <EstimationForm
          countryCode={countryCode}
          estimationPresets={estimationPresets}
          onSubmit={onFormSubmit}
        />
      )}
    </>
  );
};
